import { getCookie } from 'cookies-next';
import { isIOS } from 'react-device-detect';
import { setLastKwd } from '@wconcept/wconcept-common/utils/cookie';

const WckReNewalPRT = () => {
  const isWckNewApp = () => navigator.userAgent.indexOf('wcknewapp') > -1;
  const isApp = () => navigator.userAgent.indexOf('wckapp') > -1;
  return { isWckNewApp, isApp };
};

const WckAmplitude = () => {
  const setAmpIdentify = (userProperties: {
    [key: string]: string | number;
  }) => {
    const eventParams =
      `{` +
      `"event_name": "amp_user", ` +
      `"event_value":${JSON.stringify(userProperties)}}`;
    if (isIOS) {
      window.webkit.messageHandlers.WckAmplitude.postMessage(eventParams);
    } else {
      window.WckAmplitude.WckAmplitude(eventParams);
    }
  };

  return {
    setAmpIdentify,
  };
};

const WCKAppFunction = (isAutoLogin: boolean) => {
  const setLastKeyword = (keyword: string) => {
    setLastKwd(keyword);
  };

  const getUserInfo = () =>
    `${getCookie('custno') as string}|${isAutoLogin ? 'true' : 'false'}|${
      getCookie('wckGenderValue') as string
    }|${getCookie('BasketCnt') as string}`;

  const setCookie = (name: string, value: string, exp: number) => {
    const date = new Date();
    date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};domain=.wconcept.co.kr;expires=${date.toUTCString()};path=/`;
  };

  const changeGender = (value: 'Women' | 'Men') => {
    setCookie('wckGenderValue', value, 10000);
  };

  const getBasketCnt = () => getCookie('BasketCnt') as string;

  const actionHistoryBack = () => {
    if (WckReNewalPRT().isWckNewApp()) {
      document.location.href = 'wconceptkr://webViewBack';
    } else {
      window.history.back();
    }
  };

  const nativeHeaderOn = () => {
    try {
      if (WckReNewalPRT().isWckNewApp()) {
        document.location.href = 'wconceptkr://headerDimOn';
      }
    } catch (e) {
      console.error(e);
    }
  };

  const nativeHeaderOff = () => {
    try {
      if (WckReNewalPRT().isWckNewApp()) {
        document.location.href = 'wconceptkr://headerDimOff';
      }
    } catch (e) {
      console.error(e);
    }
  };

  return {
    setLastKeyword,
    getUserInfo,
    changeGender,
    getBasketCnt,
    actionHistoryBack,
    nativeHeaderOn,
    nativeHeaderOff,
  };
};

export { WckReNewalPRT, WCKAppFunction, WckAmplitude };
